import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/tailwind.css';
import './styles/index.css';

const container = document.getElementById('root');
const root = createRoot(container);

/**
 * PWA functionality (service worker + offline caching) has been removed.
 * This unregisters any service worker left over from a previous deploy
 * and clears its caches, so returning users stop getting stale/offline
 * responses (which was masking session-expiry redirects to /login).
 */
async function unregisterServiceWorkersAndClearCaches() {
  if (!('serviceWorker' in navigator)) return;

  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));

    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map((name) => caches.delete(name)));
    }
  } catch (error) {
    console.error('Failed to unregister service workers / clear caches:', error);
  }
}

// Start application
// MSW is disabled - using real Django backend
async function startApp() {
  // Only enable MSW if explicitly requested via env var
  if (import.meta.env.VITE_ENABLE_MOCKS === 'true') {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
    });
    console.warn('🔧 Mock Service Worker started');
  } else {
    console.warn(
      '🔗 Using Django backend at:',
      import.meta.env.VITE_API_URL || 'http://localhost:8000'
    );

    // Clean up any leftover PWA service worker / cache from older builds.
    // Skipped when MSW mocking is on, since that registers its own
    // (unrelated) mockServiceWorker.js and this would unregister it too.
    unregisterServiceWorkersAndClearCaches();
  }

  root.render(<App />);
}

startApp();
